import { handleFloatingPromise } from "@solvari/utils";

import { initExpertSite } from "./expertSite";

import "./components/accordion.js";
import "./components/sidebarCta.js";

import "../styles/light.css";

handleFloatingPromise(initExpertSite());
